var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = require("!!babel-loader!vue-loader/lib/selector?type=script&index=0!./Loading.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-54c8cf1a!vue-loader/lib/selector?type=template&index=0!./Loading.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./src/components/app/Loading.vue
// module id = 231
// module chunks = 18